import { PORTAL_ROLE, isRoleAllowed, clearPortalSession } from './portalRole';

export default (to, from, next) => {
  const token = localStorage.getItem('cohToken');
  const portalRole = localStorage.getItem('portal_role');
  const roleId = localStorage.getItem('role_id');

  if (
    token &&
    token.length > 0 &&
    portalRole === PORTAL_ROLE &&
    isRoleAllowed(roleId)
  ) {
    next();
  } else {
    clearPortalSession();
    next('/manage/sessions/signIn');
  }
};
